import { useCallback, useRef, useState, useEffect } from 'react';

/**
 * Hook to manage invalid file feedback UI state with auto-dismiss
 */
const useInvalidFeedback = () => {
  const [isFileInvalid, setIsFileInvalid] = useState(false);
  const invalidTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Show invalid file UI feedback for a short duration
  const showInvalidFeedback = useCallback(() => {
    // Clear any existing timeout
    if (invalidTimeoutRef.current) {
      clearTimeout(invalidTimeoutRef.current);
    }
    setIsFileInvalid(true);
    // Auto-hide after 3 seconds
    invalidTimeoutRef.current = setTimeout(() => {
      setIsFileInvalid(false);
    }, 3000);
  }, []);

  const clearInvalidFeedback = useCallback(() => {
    setIsFileInvalid(false);
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (invalidTimeoutRef.current) {
        clearTimeout(invalidTimeoutRef.current);
      }
    };
  }, []);

  return {
    isFileInvalid,
    showInvalidFeedback,
    clearInvalidFeedback,
  };
};

export default useInvalidFeedback;
